/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react'
import { faFloppyDisk, faRedo, faSync, faUndo, faXmark } from '@fortawesome/free-solid-svg-icons'
import { GoogleMap, Polygon } from '@react-google-maps/api'
import { Button, Col, Drawer, Form, Row } from 'antd'

//STYLES
import { CardDados, Container } from './styles'

//APP
import { useAccess } from '../../../../../context/useAccess'
import { calculoAreaCoord, optionsMap, polyGetPath } from '../../../../../services/Afins'
import { geralKmlPolygon } from '../../../../../Components/gerarKml'
import { postTalhaoCultivavel, putTalhaoCultivavel } from '../../../../../services/TalhaoSafra'
import { postTalhao, putTalhao } from '../../../../../services/Talhao'

//COMPONENT
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../../utils/alert'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { TitleH3 } from '../../../../../Components/CustomUi/titleH3'
import Input from '../../../../../Components/CustomUi/input'
import WaterMarker from '../../../../../Components/WaterMarker'



interface DesenhoTalhaoProps {
  isOpen: boolean
  update?: number
  onClose: (data: boolean) => void
  cultivavel?: boolean
  talhao: {
    nome: string
    propriedadeCod: number
    propriedadeNome: string
    fitBounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral
    polygon: google.maps.LatLngLiteral[] | google.maps.LatLng[]
  }
  onSuccess?: () => void
  atualizarLista?: Function
}

const DesenhoTalhaoNovoNew: React.FC<DesenhoTalhaoProps> = ({
  isOpen,
  talhao,
  onClose,
  update = 0,
  cultivavel,
  onSuccess,
  atualizarLista,
}) => {
  const [map, setMap] = useState<google.maps.Map>()
  const [polygon, setPolygon] = useState<google.maps.Polygon>()
  const [visible, setVisible] = useState(false)

  const [getAreaTalhao, setGetAreaTalhao] = useState<number>(0)

  const [undoPolygon, setUndoPolygon] = useState([])
  const [redoPolygon, setRedoPolygon] = useState([])
  const [salvar, setSalvar] = useState(false)
  const [carregando_salvar, setCarregando_salvar] = useState<boolean>(false)
  const [nome, setNome] = useState<string>('')
  const [area, setArea] = useState<string>('')
  const [codPropriedade, setCodPropriedade] = useState<number>(null)

  const [form] = Form.useForm()
  const { setAtualizarArea, atualizarArea } = useAccess()

  useEffect(() => {
    setVisible(isOpen)
  }, [isOpen])

  const onFinish = async () => {
    try {
      loadingAlert({ msg: 'Salvando...', id: 'cadastro_talhao' })
      setCarregando_salvar(true)

      const polygonFinish = polyGetPath(polygon)

      const kml = geralKmlPolygon(polygonFinish, nome)

      const cripto = btoa(kml)

      const arquivo = `data:@file/xml;base64,${cripto}`

      const dados = {
        nome: nome,
        cod_propriedade: update,
        arquivo: arquivo,
        status: 1,
        area: String(area),
      }

      if (update <= 0) {
        const response = cultivavel
          ? await postTalhaoCultivavel(talhao.propriedadeCod, dados)
          : await postTalhao(talhao.propriedadeCod, dados)
        if (response.status === 201) {
          successAlert('Talhão cadastrado com sucesso!', 5000, 'cadastro_talhao')
          onSuccess?.()
          setAtualizarArea(!atualizarArea)
          atualizarLista?.()
          setSalvar(false)
          setCarregando_salvar(false)
        }
      } else {
        const response = cultivavel
          ? await putTalhaoCultivavel(talhao.propriedadeCod, update, dados)
          : await putTalhao(talhao.propriedadeCod, update, dados)
        if (response.status === 200) {
          successAlert('Talhão atualizado com sucesso!', 5000, 'cadastro_talhao')
          onSuccess?.()
          setAtualizarArea(!atualizarArea)
          atualizarLista?.()
          setSalvar(false)
          setCarregando_salvar(false)
        }
        setCarregando_salvar(false)
      }
    } catch (error) {
      setCarregando_salvar(false)

      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha ao registrar talhão!', 5000, 'cadastro_talhao')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha ao registrar talhão!', 5000, 'cadastro_talhao')
          })
        }
      } else {
        destroyAlert()
      }
    }
  }

  const handleUndo = () => {
    const old = [...undoPolygon]

    const index = undoPolygon.length - 1
    let newArray = []
    let newCoord = []
    old.forEach((data, i) => {
      if (data !== undefined) {
        if (index !== i) {
          const info = data
          newArray = [...newArray, info]
        } else {
          setRedoPolygon([...redoPolygon, data])
          newCoord = [old[i - 1]]
        }
      }

      return { newArray, newCoord }
    })

    polygon.setPaths(newCoord)

    setGetAreaTalhao(calculoAreaCoord(newCoord))
    form.setFieldsValue({ area: calculoAreaCoord(newCoord) })

    setUndoPolygon(newArray)
  }

  const handleRedo = () => {
    const old = [...redoPolygon]

    const index = redoPolygon.length - 1
    let newArray = []
    let newCoord = []
    old.forEach((data, i) => {
      if (data !== undefined) {
        if (index !== i) {
          const info = data
          newArray = [...newArray, info]
        } else {
          setUndoPolygon([...undoPolygon, data])
          newCoord = [old[i]]
        }
      }

      return { newArray, newCoord }
    })

    polygon.setPaths(newCoord)

    setGetAreaTalhao(calculoAreaCoord(newCoord))
    form.setFieldsValue({ area: calculoAreaCoord(newCoord) })

    setRedoPolygon(newArray)
  }

  const handleResetDesenho = () => {
    setUndoPolygon([])
    setRedoPolygon([])
    polygon.setPath([])
    form.setFieldsValue({ area: calculoAreaCoord([talhao.polygon]) })
    destroyAlert()
  }

  const handleMouseUpPolygon = (e: google.maps.MapMouseEvent) => {
    const dados = polygon
      .getPath()
      .getArray()
      .map((item) => {
        return { lat: item.lat(), lng: item.lng() }
      })

    setUndoPolygon([...undoPolygon, dados])

    const ha = calculoAreaCoord([dados])
    setSalvar(true)

    form.setFieldsValue({ area: ha })
  }

  useEffect(() => {
    if (update > 0) {
      // form.setFieldsValue({
      //   nome: talhao.nome,
      //   area: calculoAreaCoord([talhao.polygon]),
      //   cod_propriedade: talhao.propriedadeCod,
      // })
      setNome(talhao.nome)
      setArea(String(calculoAreaCoord([talhao.polygon])))
      setCodPropriedade(talhao.propriedadeCod)

      if (map && polygon) {
        map.fitBounds(talhao.fitBounds)
        polygon.setPath(talhao.polygon)
      }
    } else {
      form.resetFields()
    }
  }, [talhao])

  useEffect(() => {
    if (map && polygon) {
      if (polygon.getPath().getArray().length <= 0) {
        map.fitBounds(talhao.fitBounds)
        polygon.setPath(talhao.polygon)
      }
    }
  })

  useEffect(() => {
    if (map && polygon) {
      setTimeout(() => {
        handleResetDesenho()
      }, 500)
    }
  }, [talhao])

  const handleRightClick = (event: google.maps.MouseEvent) => {
    if (polygon) {
      const path = polygon.getPath()
      const index = path.getArray().findIndex((latlng) => latlng.equals(event.latLng))
      if (index > -1) {
        path.removeAt(index)
      }
    }
  }
  useEffect(() => {
    if (polygon) {
      const listener = polygon.addListener('rightclick', handleRightClick)
      return () => {
        google.maps.event.removeListener(listener)
      }
    }
  }, [polygon])

  return (
    <Container>
      <Drawer
        open={visible}
        closeIcon={false}
        headerStyle={{ display: 'none' }}
        bodyStyle={{ padding: 0 }}
        onClose={() => onClose(false)}
        style={{ position: 'absolute' }}
        placement='bottom'
        height='100%'
      >
        {/* @ts-ignore */}
        <GoogleMap
          onLoad={setMap}
          mapContainerStyle={{ minWidth: '100%', height: '100vh' }}
          options={optionsMap}
          zoom={2}
        >
          <Polygon
            onLoad={(data) => setPolygon(data)}
            onMouseUp={handleMouseUpPolygon}
            options={{
              fillColor: 'cyan',
              strokeColor: 'cyan',
              strokeWeight: 4,
              fillOpacity: 0.45,
              clickable: true,
              draggable: false,
              editable: true,
              geodesic: false,
            }}
          />
          <CardDados>
            <div style={{ display: 'flex', marginTop: '10px'}}>
              <ButtonCustom
                onClick={() => onClose(false)}
                type='tertiary'
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
              >
                Fechar
              </ButtonCustom>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                padding: '15px',
                gap: '10px',
              }}
            >
              <TitleH3>Dados talhão</TitleH3>
              <Input
                label='Nome'
                placeholder='Digite o nome do talhão'
                value={nome}
                onChange={setNome}
              />
              <Input
                label='Área(ha)'
                placeholder='Digite a área do talhão'
                value={area}
                onChange={setArea}
              />
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', gap: '5px' }}>
                  <ButtonCustom
                    disabled={undoPolygon.length <= 1}
                    onClick={handleUndo}
                    style={{ color: 'white' }}
                    title='Desfazer'
                    icon={<FontAwesomeIcon icon={faUndo} />}
                  />
                  <ButtonCustom
                    disabled={redoPolygon.length <= 0}
                    onClick={handleRedo}
                    style={{ color: 'white' }}
                    title='Refazer'
                    icon={<FontAwesomeIcon icon={faRedo} />}
                  />
                  <ButtonCustom
                    onClick={handleResetDesenho}
                    style={{ color: 'white' }}
                    type='primary'
                    danger
                    title='Resetar'
                    icon={<FontAwesomeIcon icon={faSync} />}
                  />
                </div>
                <ButtonCustom icon={<FontAwesomeIcon icon={faFloppyDisk} />} onClick={onFinish}>
                  {update > 0 ? 'Atualizar talhão' : 'Gerar talhão'}
                </ButtonCustom>
              </div>
            </div>
          </CardDados>
          <WaterMarker placement='topLeft' />
        </GoogleMap>
      </Drawer>
    </Container>
  )
}

export default DesenhoTalhaoNovoNew